import {memoize} from '@packages/utilities/memo';
import {type PageRecordType} from '@packages/systems/core/records/PageRecord';
import {type CollectionsType} from '@packages/systems/core/records/CollectionStateType';
import {Component, Expressions} from '@packages/systems/wfdl';
import {WebflowEnvironments} from '@packages/systems/core-constants';

import {getElementBindingContextNode} from './BindingContextGraph';

export default memoize(getElementConnectionOptions);

function getElementConnectionOptions(
  elementId: string,
  currentComponent: Component.ComponentType,
  componentMap: Component.ComponentMap,
  page: PageRecordType | null,
  collections: CollectionsType
) {
  const tree = Component.getRender(currentComponent);
  const element = Expressions.getElementById(tree, elementId);

  if (!element) {
    return [];
  }

  const bindingContextNode = getElementBindingContextNode(
    element.id,
    currentComponent,
    componentMap,
    page,
    collections,
    WebflowEnvironments.DESIGNER
  );

  if (!bindingContextNode) {
    return [];
  }

  return bindingContextNode.getElementConnectionOptions(element);
}
